import { render, staticRenderFns } from "./ServiceFiltersPageManager.vue?vue&type=template&id=37e4ede8&"
import script from "./ServiceFiltersPageManager.vue?vue&type=script&lang=js&"
export * from "./ServiceFiltersPageManager.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFiltersPageManager.vue?vue&type=style&index=0&id=37e4ede8&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e4ede8')) {
      api.createRecord('37e4ede8', component.options)
    } else {
      api.reload('37e4ede8', component.options)
    }
    module.hot.accept("./ServiceFiltersPageManager.vue?vue&type=template&id=37e4ede8&", function () {
      api.rerender('37e4ede8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ServiceFilters/ServiceFiltersPageManager.vue"
export default component.exports